/**
 * Servicio para guardar feedback del usuario
 * El feedback se guarda temporalmente y se incluye en la conversación cuando se guarda
 */

import conversationSaverService from './conversationSaverService';

export interface FeedbackData {
  internal_interaction_id: string; // ID de la conversación
  rating: number; // 1-5
  feedback_text?: string; // Texto opcional del usuario
  created_at: string; // Fecha de creación
}

export class FeedbackService {
  /**
   * Guardar feedback temporalmente
   * Se guarda en localStorage y se incluirá en la conversación cuando se guarde
   */
  async sendFeedback(rating: number, feedbackText: string): Promise<void> {
    // Obtener el ID de la conversación actual
    const internalInteractionId = conversationSaverService.getCurrentInteractionId();
    
    if (!internalInteractionId) {
      throw new Error('No hay una conversación activa para asociar el feedback');
    }

    const feedbackData: FeedbackData = {
      internal_interaction_id: internalInteractionId,
      rating,
      feedback_text: feedbackText.trim() || undefined,
      created_at: new Date().toISOString(),
    };

    try {
      // Guardar temporalmente en localStorage
      // Se incluirá en el payload cuando se guarde la conversación
      const storageKey = `feedback_${internalInteractionId}`;
      localStorage.setItem(storageKey, JSON.stringify(feedbackData));

      // También guardar en conversationSaverService para acceso inmediato
      conversationSaverService.setPendingFeedback(feedbackData);

      // console.log('[FeedbackService] ✅ Feedback guardado temporalmente:', {
      //   internalInteractionId,
      //   rating,
      //   hasText: !!feedbackText.trim(),
      // });
    } catch (error) {
      // console.error('[FeedbackService] ❌ Error al guardar feedback:', error);
      throw new Error(`Error al guardar feedback: ${error instanceof Error ? error.message : 'Error desconocido'}`);
    }
  }

  /**
   * Obtener feedback guardado temporalmente para una conversación
   */
  getStoredFeedback(internalInteractionId: string): FeedbackData | null {
    try {
      const storageKey = `feedback_${internalInteractionId}`;
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      // console.error('[FeedbackService] Error al leer feedback guardado:', error);
    }
    return null;
  }
}

export const feedbackService = new FeedbackService();
export default feedbackService;
